import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'

export const HidePasswordIcon: FC<IconProps> = ({ width = 20, height = 20, ...rest }) => (
  <Icon type="hidePassword" width={width} height={height} alt="" ignoreRtl {...rest} />
)